var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Tooltip } from '@material-ui/core';
import ChildComponent from '../ChildComponent';
import EventContext from '../context/event-context';
import StateContext from '../context/state-context';
import { StyledDivContainer, TextComponent } from './Grid';
var StyledSpan = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
var StyledToolTip = styled(Tooltip)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) { return ({ ...props.componentStyle }); });
export function TooltipStyled(props) {
    var description = props.description, componentStyle = props.componentStyle;
    return (React.createElement(StyledToolTip, { title: description !== null && description !== void 0 ? description : '', componentStyle: componentStyle },
        React.createElement(ChildComponent, { children: props.children })));
}
export function Span(props) {
    var text = props.text, componentStyle = props.componentStyle;
    return React.createElement(StyledSpan, { componentStyle: componentStyle }, text);
}
export function Button(props) {
    var _a;
    var label = props.label, id = props.id, _b = props.componentStyle, componentStyle = _b === void 0 ? {} : _b, _c = props.textStyle, textStyle = _c === void 0 ? {} : _c, _d = props.isIndicator, isIndicator = _d === void 0 ? false : _d, restProps = __rest(props, ["label", "id", "componentStyle", "textStyle", "isIndicator"]);
    var _e = useContext(EventContext), _onButtonClick = _e._onButtonClick, _onIndicatorButtonClick = _e._onIndicatorButtonClick;
    var state = useContext(StateContext);
    var onButtonClick = function (evt) {
        isIndicator ? _onIndicatorButtonClick(id) : _onButtonClick(id);
    };
    var labelFromState = state[id + "_label"];
    var isEnabled = (_a = state[id + "_isEnabled"]) !== null && _a !== void 0 ? _a : true;
    var blinkingTime = state[id + "_blinkingTime"];
    var blinkingColor1 = state[id + "_blinkingColor1"];
    var blinkingColor2 = state[id + "_blinkingColor2"];
    return (React.createElement(StyledDivContainer, __assign({ componentStyle: __assign(__assign({}, componentStyle), { cursor: 'pointer' }), id: id, onClick: onButtonClick, fontColor: isEnabled ? state[id + "_fontColor"] : 'rgba(255,255,255,0.5)', backgroundColor: isEnabled ? state[id + "_backgroundColor"] : 'transparent', blinkingTime: blinkingTime, blinkingColor1: blinkingColor1, blinkingColor2: blinkingColor2 }, restProps),
        React.createElement("span", { className: "button-internal" },
            React.createElement(TextComponent, { componentStyle: textStyle, label: labelFromState !== null && labelFromState !== void 0 ? labelFromState : label }))));
}
export function ToolTipButton(props) {
    var label = props.label, id = props.id, description = props.description, _a = props.toolTipStyle, toolTipStyle = _a === void 0 ? {} : _a, _b = props.textStyle, textStyle = _b === void 0 ? {} : _b, _c = props.componentStyle, componentStyle = _c === void 0 ? {} : _c, onClick = props.onClick;
    var onButtonClick = function (evt) {
        onClick && onClick(id);
    };
    return (React.createElement(StyledDivContainer, { componentStyle: __assign(__assign({}, componentStyle), { cursor: 'pointer' }), id: id, onClick: onButtonClick },
        React.createElement(StyledToolTip, { title: description !== null && description !== void 0 ? description : '', componentStyle: toolTipStyle },
            React.createElement(StyledSpan, { componentStyle: textStyle }, label))));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=Button.js.map